export const getInstitutionCohortDomain = (institutionN: number) => {
    let domain: any[] = [];
    if (institutionN >= 5) {
        domain = ["Your Institution", "Cohort"];
    } else {
        domain = ["Cohort"];
    }
    return domain;
}